import { render, staticRenderFns } from "./CompanyChangePassword.vue?vue&type=template&id=ebf1b668&scoped=true&"
import script from "../../services/company/company-change-password.js?vue&type=script&lang=js&"
export * from "../../services/company/company-change-password.js?vue&type=script&lang=js&"
import style0 from "./CompanyChangePassword.vue?vue&type=style&index=0&id=ebf1b668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf1b668",
  null
  
)

export default component.exports